// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"9f0b2d08","878":"55cac553"}[chunkId] + ".chunk.js";
};